import React from "react";
import { Link } from "react-router";

function PurchaseComplete(props) {
  return (
    <div>
      {/*Title */}
      <h1
        className={`display-4 text-center mt-2 ${
          props.data.purchase_status_success ? "text-success" : "text-danger"
        }`}
      >
        {props.data.purchase_status_success ? "Successful" : "Failed"}
      </h1>

      {/*Payment details */}
      <div className="row justify-content-center text-center mt-5">
        <div className="col-sm-4 mt-3">
          <div className="row border-bottom">
            <div className="col-sm-6 mt-3 text-start">
              <label className="text-muted fs-5">Product details:</label>
            </div>
            <div className="col-sm-6 mt-3 text-end">
              <label className="fs-5">{props.data.item_name}</label>
            </div>
          </div>

          <div className="row border-bottom">
            <div className="col-sm-6 mt-3 text-start">
              <label className="text-muted fs-5">Price:</label>
            </div>
            <div className="col-sm-6 mt-3 text-end">
              <label className="fs-5">{props.data.item_price}</label>
            </div>
          </div>

          <div className="row border-bottom">
            <div className="col-sm-6 mt-3 text-start">
              <label className="text-muted fs-5">Transaction id:</label>
            </div>
            <div className="col-sm-6 mt-3 text-end">
              <label className="fs-5">{props.data.transaction_id}</label>
            </div>
          </div>

          <div className="row border-bottom">
            <div className="col-sm-6 mt-3 text-start">
              <label className="text-muted fs-5">Reference id:</label>
            </div>
            <div className="col-sm-6 mt-3 text-end">
              <label className="fs-5">{props.data.reference_id}</label>
            </div>
          </div>
        </div>
      </div>

      {/* Message */}
      <p className="bg-secondary rounded-pill text-light text-center mt-5 p-3 mx-5">
        {props.data.purchase_message}
      </p>

      {/* Go to my account */}
      <div className="text-center justify-content-center mt-5">
        <Link to="/myaccount">My Account</Link>
      </div>
    </div>
  );
}

export default PurchaseComplete;
